<template>
  <div
    class="container container-main header-main-kids bg-white z-10"
    :class="{
      'header-shadow': isOpenMenu,
    }"
  >
    <div class="flex w-full h-full items-center xl:gap-[26px]">
      <button
        v-if="!isOpenMenu"
        type="button"
        class="w-[32px] h-[32px] md:w-[44px] md:h-[44px] overflow-hidden xl:hidden justify-center"
        @click="$emit('toogle-menu')"
      >
        <icon-burger-menu class="text-[#052F41]" />
      </button>
      <button
        v-else
        type="button"
        class="flex items-center justify-center md:p-0 gap-2 uppercase w-[32px] h-[32px] md:w-[44px] md:h-[44px] text-primaryrounded-[5px] overflow-hidden xl:hidden"
        @click="$emit('toogle-menu')"
      >
        <icon-close class="text-[#052F41]" />
      </button>
      <div v-if="!isInFrame()" class="mx-auto ml-[12px] lg:ml-auto xl:mr-0 xl:mx-0 xl:shrink-0">
        <figure class="flex items-center h-[140px]">
          <router-link :to="{ name: '/home' }" @click="$emit('close-mobile-menu')">
            <img loading="lazy" src="/svg/vote_logo.svg" alt="Vote" class="header-main-kids__logo w-auto" />
          </router-link>
        </figure>
      </div>
      <div class="flex md:hidden"></div>
      <HeaderNavKids class="xl:flex-1 h-full" @open-partner-form="(type) => $emit('open-partner-form', type)" />
    </div>
  </div>
</template>

<script setup>
import { isInFrame } from "@academy/utils"

import HeaderNavKids from "./header-nav/HeaderNavKids.vue"
import IconClose from "@/components/icons/IconClose.vue"
import IconBurgerMenu from "@/components/icons/IconBurgerMenu.vue"

defineProps({
  isOpenMenu: {
    type: Boolean,
    required: true,
  },
  isMobileSearch: {
    type: Boolean,
    required: true,
  },
})

defineEmits({
  "toogle-menu": null,
  "toogle-mobile-search": null,
  "close-mobile-menu": null,
  "open-partner-form": null,
  search: (value) => typeof value === "string",
})
</script>

<style lang="scss" scoped>
.header-main-kids {
  height: 200px;
  display: flex;
  align-items: center;

  &__logo {
    height: 100px;
    width: auto;
    display: block;
  }
}

.sticky {
  position: relative;
  @media (max-width: 768px) {
    @apply fixed;
  }
}

.header-shadow {
  @media (max-width: 768px) {
    @apply shadow-[0_4px_4px_rgba(0,0,0,0.05)];
  }
}
</style>
